<script setup lang="ts">
import '@/assets/scss/form.scss'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import CSInputText from '@/onenetwork/components/form/CSInputText.vue'
import ImagePicker from '@/onenetwork/components/image_picker/ImagePicker.vue'
import RegionPicker from '@/onenetwork/components/region_picker/RegionPicker.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { Form } from '@primevue/forms'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import moment from 'moment'
import { useConfirm } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { uuid } from 'vue3-uuid'
import AccountAPI from '../constants/account.api.uri.const'
import { genderOptions, initialValuesKYC, parseFormDataKYC } from '../helper/form'
import { schemaKyc } from '../helper/validationAccountSchema'
import { Icon } from '@iconify/vue/dist/iconify.js'
import CsButton from '@/components/ui/button/CsButton.vue'

const confirm = useConfirm()

interface Props {
  account: any
  currentTab?: string
  isUpdate?: boolean
}



const props = defineProps({
  account: {},
  currentTab: '',
  isUpdate: {
    type: Boolean,
    required: false,
    default: false
  }
})

const toast = useToast()
const editable = ref(false)
const loading = ref(false)
const formRef = ref()
const formReady = ref(false)
const initialValues: any = ref(initialValuesKYC(props.account?.kyc_information))
const selectedRegion = ref([])
const selectedDistrict = ref([])
const selectedWard = ref([])

const isShowEditButton = computed(() => {
  return props?.account?.kyc_information && props?.account?.kyc_information?.processing_status === 'approved' && props?.isUpdate
})

const requestKYC = async (id?: number) => {
  if (!id) return {}
  try {
    const res = await APIClient.get(AccountAPI.kyc.detail.replace(':id', id.toString()))
    if (res.data.code === 200) {
      initialValues.value = initialValuesKYC(res.data?.data) || {}
      formReady.value = true
    }
  } catch (e) {

  }
}

const resolver = yupResolver(schemaKyc)

const updateKyc = async (data: any) => {
  loading.value = true;
  try {
    const res = await APIClient.put(AccountAPI.kyc.update.replace(':id', data.id), data)
    if (res.data.code === 200) {
      toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Cập nhật thành công',
        life: 3000,
      })
      initialValues.value = initialValuesKYC(res.data?.data)
      editable.value = false;
      loading.value = false;
      nextTick(() => {
        formRef.value?.reset();
      })
      return;
    }
  } catch (e: any) {
    loading.value = false;
    const errorMessage = e.response?.data?.errors[0]?.error || 'Đã có lỗi xảy ra'
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 })
  }
}

const onFormSubmit = ({ values, valid }: { values: Record<string, any>; valid: boolean }) => {

  if (!valid) return
  console.log(values, 'values');
  console.log(parseFormDataKYC(values), 'parseFormDataKYC');
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: () => {
      updateKyc(parseFormDataKYC(values))
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    },
  })
}

const handleChangeImage = (image: any, type: string) => {
  if(type === 'front_id_image'){
    formRef.value?.setFieldValue('front_id_image', image.uuid)
  } else if(type === 'back_id_image'){
    formRef.value?.setFieldValue('back_id_image', image.uuid)
  } else if(type === 'selfie_image'){
    formRef.value?.setFieldValue('selfie_image', image.uuid)
  }
}

watch(
  () => props.account,
  () => {
    requestKYC(props?.account?.kyc_information?.id)
  },
)

const handleRegionChange = (value: any) => {
  if (value[0]?.id) {
    initialValues.value.province_id = value[0]?.id
    formRef.value?.setFieldValue('province_id', value[0]?.id)
  } else {
    initialValues.value.province_id = null
    formRef.value?.setFieldValue('province_id', null)
  }
  selectedDistrict.value = [];
  selectedWard.value = [];
  formRef.value?.setFieldValue('district_id', null);
  formRef.value?.setFieldValue('ward_id', null);
}

const handleDistrictChange = (value: any) => {
  if (value[0]?.id) {
    initialValues.value.district_id = value[0]?.id
    formRef.value?.setFieldValue('district_id', value[0]?.id)
  } else {
    initialValues.value.district_id = null
    formRef.value?.setFieldValue('district_id', null)
  }
  selectedWard.value = [];
}

const handleWardChange = (value: any) => {
  if (value[0]?.id) {
    initialValues.value.ward_id = value[0]?.id
    formRef.value?.setFieldValue('ward_id', value[0]?.id)
  } else {
    initialValues.value.ward_id = null
    formRef.value?.setFieldValue('ward_id', null)
  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '1') {
    requestKYC(props?.account?.kyc_information?.id)
  }
})

onMounted(() => {
  requestKYC(props?.account?.kyc_information?.id)
})

const cancelEdit = () => {
  editable.value = false;
  initialValues.value.province_id = initialValues.value?.province?.id
  initialValues.value.district_id = initialValues.value?.district?.id
  initialValues.value.ward_id = initialValues.value?.ward?.id
  formRef.value?.reset()
}

</script>

<template>
  <div class="flex justify-between"
    v-if="isShowEditButton">
    <div></div>
    <div class="flex gap-2">
      <!-- <button type="button" class="btn btn-cs outline" v-if="!editable" @click="()=>{
        editable = true
      }">
      <span>Chỉnh sửa</span>
      </button>
      <button type="button" class="btn btn-cs outline" v-if="editable" @click="cancelEdit">
        <span>Huỷ chỉnh sửa</span>
      </button> -->
<!--      <CsButton-->
<!--        type="button"-->
<!--        icon="ri:edit-2-fill"-->
<!--        text="Chỉnh sửa"-->
<!--        :visible="!editable"-->
<!--        @click="editable = true"-->
<!--      />-->
<!--      <CsButton-->
<!--        type="button"-->
<!--        icon="ri:close-circle-fill"-->
<!--        text="Huỷ chỉnh sửa"-->
<!--        variant="danger"-->
<!--        :visible="editable"-->
<!--        @click="cancelEdit"-->
<!--      />-->
    </div>
  </div>
  <div class="py-3">
    <div v-if="!props?.account?.kyc_information">
      <h4 class="text-center text-[12px] font-600">Chưa đăng kí KYC</h4>
    </div>
    <div v-else-if="formReady">
      <Form
        v-slot="$form"
        :initial-values="initialValues"
        ref="formRef"
        :resolver="resolver"
        @submit="onFormSubmit"
        class="flex flex-col w-full md:flex-row gap-10 my-4"
      >
      <!-- {{ initialValues }} -->
        <InputText name="id" type="text" hidden class="form-control" disabled />
        <InputText name="province_id" type="text" hidden class="form-control" disabled />
        <InputText name="district_id" type="text" hidden class="form-control" disabled />
        <InputText name="ward_id" type="text" hidden class="form-control" disabled />
        <InputText name="activation_status" type="text" hidden class="form-control" disabled />
        <div class="flex flex-col w-full md:max-w-[50%]">
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Họ và tên:</div>
            <div class="flex-3">
              <InputText name="full_name" type="text" class="form-control" :disabled="!editable"/>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Ngày sinh:</div>
            <div class="flex-3">
              <DatePicker
                class="form-control"
                name="birthday"
                :disabled="!editable"
                :manual-input="false"
              />
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Địa chỉ thường trú:</div>
            <div class="flex-3">
              <CSInputText :model-value="initialValues?.address" name="address" type="text" class="form-control"  :editable="!editable" />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.address?.invalid && editable"
              >
                {{ $form.address.error.message }}
              </span>
            </div>
          </div>
<!--          <div class="flex mb-3 gap-3">-->
<!--            <div class="flex-1 text-right"></div>-->
<!--            <div class="flex-3">-->
<!--            <div class="flex gap-2 w-full">-->
<!--                <RegionPicker-->
<!--                  level="region"-->
<!--                  name="province_id"-->
<!--                  v-model="selectedRegion"-->
<!--                  @update:selected="handleRegionChange"-->
<!--                  :selectedId="initialValues?.province_id"-->
<!--                  :editable="!editable"-->
<!--                  :error="$form.province_id?.error?.message"-->
<!--                />-->

<!--                <RegionPicker-->
<!--                  level="district"-->
<!--                  name="district_id"-->
<!--                  :parentId="selectedRegion[0]?.id"-->
<!--                  v-model="selectedDistrict"-->
<!--                  @update:selected="handleDistrictChange"-->
<!--                  :selectedId="initialValues?.district_id"-->
<!--                  :editable="!editable"-->
<!--                  :error="$form.district_id?.error?.message"-->
<!--                />-->

<!--                <RegionPicker-->
<!--                  level="ward"-->
<!--                  name="ward_id"-->
<!--                  :regionId="selectedRegion[0]?.id"-->
<!--                  :parentId="selectedDistrict[0]?.id"-->
<!--                  v-model="selectedWard"-->
<!--                  @update:selected="handleWardChange"-->
<!--                  :selectedId="initialValues?.ward_id"-->
<!--                  :editable="!editable"-->
<!--                  :error="$form.ward_id?.error?.message"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Giới tính:</div>
            <div class="flex-3">
              <Select
                name="gender"
                :options="genderOptions"
                optionLabel="name"
                placeholder="Chọn giới tính"
                class="form-control"
                :disabled="!editable"
              />
              <span class="italic text-[12px] text-red-500" v-if="$form.gender?.invalid && editable">
                {{ $form.gender.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Nguyên quán:</div>
            <div class="flex-3">
              <InputText name="hometown" type="text" class="form-control" :disabled="!editable" />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.hometown?.invalid && editable"
              >
                {{ $form.hometown.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Số CCCD:</div>
            <div class="flex-3">
              <InputText
                name="national_id_number"
                type="number"
                class="form-control"
                :disabled="!editable"
              />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.national_id_number?.invalid && editable"
              >
                {{ $form.national_id_number.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Ngày cấp:</div>
            <div class="flex-3">
              <!-- <InputText name="issue_date" type="text" class="form-control" :disabled="!editable" /> -->
              <DatePicker
                class="form-control"
                name="issue_date"
                :disabled="!editable"
                :manual-input="false"
              />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.issue_date?.invalid && editable"
              >
                {{ $form.issue_date.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Nơi cấp:</div>
            <div class="flex-3">
              <InputText
                name="issue_place"
                type="text"
                class="form-control"
                :disabled="!editable"
              />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.issue_place?.invalid && editable"
              >
                {{ $form.issue_place.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Ngày hết hạn:</div>
            <div class="flex-3">
              <!-- <InputText name="expiration_date" type="text" class="form-control" :disabled="!editable" /> -->
              <DatePicker
                class="form-control"
                name="expiration_date"
                :disabled="!editable"
                :manual-input="false"
              />
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Ngày yêu cầu KYC:</div>
            <div class="flex-3">
              <DatePicker
                class="form-control"
                name="kyc_request_date"
                :disabled="!editable"
                :manual-input="false"
              />
              <span
                class="italic text-[12px] text-red-500"
                v-if="$form.kyc_request_date?.invalid && editable"
              >
                {{ $form.kyc_request_date.error.message }}
              </span>
            </div>
          </div>
          <div class="flex mb-3 gap-3">
            <div class="flex-1 text-right">Trạng thái KYC:</div>
            <div class="flex-3">
              <TagCell
                :data="initialValues?.kyc_status_label"
                :cell-config="{ type: 'kyc_status' }"
                class="!font-[300] !text-[11px] whitespace-nowrap"
              />
            </div>
          </div>
          <div class="flex mb-3 gap-3" v-if="editable">
            <div class="flex-1 text-right"></div>
            <div class="flex-3">
              <CsButton
                type="submit"
                :disabled="loading"
                :loading="loading"
                text="Lưu chỉnh sửa"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-1 gap-5">
          <div class="flex w-full flex-col">
            <image-picker
              :readonly="!editable"
              type="photo"
              :src="initialValues?.front_image_url"
              :uuid="uuid.v4().toString()"
              folder="user"
              width="100%"
              height="150px"
              :upload="true"
              @action:upload-success="(image) => handleChangeImage(image, 'front_id_image')"
            />
            <InputText name="front_id_image" type="hidden" class="form-control" />
            <h4 class="font-600 text-center text-[12px] mt-2">CCCD mặt trước</h4>
          </div>
          <div class="flex w-full flex-col">
            <image-picker
              :readonly="!editable"
              :src="initialValues?.back_image_url"
              type="photo"
              :uuid="uuid.v4().toString()"
              folder="user"
              width="100%"
              height="150px"
              :upload="true"
              @action:upload-success="(image) => handleChangeImage(image, 'back_id_image')"
            />
            <InputText name="back_id_image" type="hidden" class="form-control" />
            <h4 class="font-600 text-center text-[12px] mt-2">CCCD mặt sau</h4>
          </div>
          <div class="flex w-full flex-col">
            <image-picker
              :readonly="!editable"
              :src="initialValues?.selfie_image_url"
              type="photo"
              :uuid="uuid.v4().toString()"
              folder="user"
              width="100%"
              height="150px"
              :upload="true"
              @action:upload-success="(image) => handleChangeImage(image, 'selfie_image')"
            />
            <InputText name="selfie_image" type="hidden" class="form-control" />
            <h4 class="font-600 text-center text-[12px] mt-2">Ảnh selfie</h4>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
